module.exports = __webpack_public_path__ + "static/media/FilWrap-Light.8de127e4.webp";